import assignmentTypes from './assignmentTypes';

export const isNcleAlefAssignment = (isNcle, assignmentType) =>
  Boolean(isNcle && assignmentType === assignmentTypes.ALEF);

export const getUnassignTooltip = isNCLE =>
  isNCLE ? 'Click to unassign' : 'Click to lock';

export const getUnassignAllTooltip = isNCLE =>
  isNCLE ? 'Click to unassign for All' : 'Click to lock for All';

export const getAssignTooltip = isNCLE =>
  isNCLE ? 'Click to assign' : 'Click to unlock';

export const getAssignAllTooltip = isNCLE =>
  isNCLE ? 'Click to assign for All' : 'Click to unlock for All';
